import accounting from 'accounting';
import Vue from 'vue';
import _ from 'lodash';
import Constants from './constants';

export function removeEmptyDecimal(value: string, precision: number): string {
  const padString = `.${_.pad('', precision, '0')}`;

  if (padString.length > 1 && value.indexOf(padString) >= 0) {
    return `${value.replace(padString, '')}`;
  }

  return value;
}

Vue.filter('currency', (value: any, precision: number = 2): string => {
  const currency = accounting.formatMoney(value, {
    precision,
    symbol: Constants.CURRENCY_SYMBOL,
  });

  return removeEmptyDecimal(currency, precision);
});

Vue.filter('percentage', (value: any, precision: number = 2): string => {
  const percent = accounting.toFixed(value * 100, precision);

  return `${removeEmptyDecimal(percent, precision)}%`;
});
